import { getKnowledgeAttachmentError } from '@resolve-ai/shared';

export interface KnowledgeUploadDescription {
  filename: string;
  contentType: string;
  sizeBytes: number;
}

/**
 * What the upload-url request declares for a selected file. Checks the same
 * size cap and type allowlist the API enforces, so a bad file fails here
 * with a clear message instead of after the upload. The content type is
 * reused for the S3 PUT, so the stored object matches what was declared.
 */
export function describeKnowledgeUpload(file: File): KnowledgeUploadDescription {
  const description = {
    filename: file.name,
    contentType: file.type || 'application/octet-stream',
    sizeBytes: file.size,
  };

  const error = getKnowledgeAttachmentError(description);
  if (error) throw new Error(error);
  return description;
}
